// extracted by mini-css-extract-plugin
export var mainImage = "selectionMode-module--mainImage--2+2YP";
export var modeSelector = "selectionMode-module--modeSelector--xIIt1";
export var selected = "selectionMode-module--selected--e868f";